import { createI18n } from "vue-i18n";
import { messaggi } from "../i18n/messaggi";

export default defineNuxtPlugin(({ vueApp }) => {
  const config = useRuntimeConfig();
  const BASE_PROGETTO = config.public.base_progetto;

  // Lingua salvata (solo client). Stessa chiave del plugin localStorage, col suffisso BASE_PROGETTO.
  let linguaSalvata = "it";
  if (import.meta.client) {
    try {
      linguaSalvata = localStorage.getItem("selectedLanguage" + BASE_PROGETTO) || "it";
    } catch (e) {
      console.warn("Impossibile leggere selectedLanguage da localStorage:", e);
    }
  }

  const i18n = createI18n({
    legacy: false,
    globalInjection: true,
    locale: linguaSalvata,
    fallbackLocale: "it",
    messages: messaggi,
  });
  vueApp.use(i18n);
});
